import React from "react";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";
import Paragraph from "antd/lib/typography/Paragraph";
import Text from "antd/lib/typography/Text";
import NoSidebarLayout from "../../../components/Layout/NoSidebarLayout";
import { useStore } from "../../../store/useStore";
import { destroySession } from "../../../store/actions";
import { useHistory } from "react-router-dom";

const AppMigrationRequiredPage: React.FC = () => {
  const { dispatch } = useStore();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await dispatch(destroySession());
      history.push("/login");
    } catch (error) {}
  };

  return (
    <NoSidebarLayout>
      <div className="flex h-full items-center">
        <Alert
          type="warning"
          showIcon
          description={
            <div>
              <Paragraph>
                Your account has recently been migrated to our new iLivestock
                platform. Before you can use this web portal you must complete
                the setup process on your{" "}
                <strong>iLivestock mobile application.</strong>
              </Paragraph>
              <Paragraph>
                Once you have completed setting up your account you can click{" "}
                <Link to="/" onClick={() => window.location.reload(false)}>
                  here
                </Link>{" "}
                to continue to your dashboard.
              </Paragraph>
              <Paragraph>
                <Text strong>
                  If you want to use another account you can <Button type="link" onClick={handleLogout}>Logout</Button>
                </Text>
              </Paragraph>
            </div>
          }
          message={<div>Account migration incomplete</div>}
        ></Alert>
      </div>
    </NoSidebarLayout>
  );
};

export default AppMigrationRequiredPage;
